import React from 'react'
import { useExportToXLS } from '../../../lib/hooks/useExportToXLS'
import GhostButton from '../../Buttons/GhostButton'
import { Tooltip } from '@demandlocal/components'
import LineChart from '../LineChart'
import { ReactComponent as DownloadIcon } from '../../../images/icons/action_download.svg'

export const ImpressionLineChart = ({
  data,
  isLoading,
  sheetTitle,
  isPrevious,
}: {
  data: Array<{ date: string; impressions: number }>
  isLoading: boolean
  sheetTitle: string
  isPrevious: boolean
}) => {
  const { exportToCSV } = useExportToXLS()

  return (
    <div className={'min-h-[270px] border-2 rounded-xl'}>
      <div
        className={
          'pt-5 pb-2 px-5 flex justify-between items-center font-bold text-sm text-primary-xiketic'
        }>
        <span>Total Impressions</span>
        <div className={'flex flex-row gap-2 items-center'}>
          <span>
            {!isLoading &&
              new Intl.NumberFormat('en-US').format(
                data
                  ?.map((metric: { impressions: number }) => metric.impressions)
                  .reduce((acc: number, cur: number) => acc + cur, 0),
              )}
          </span>
          <span>
            <GhostButton
              transparent={true}
              onClick={(e) => {
                e.preventDefault()
                exportToCSV(
                  data?.map((metric) => {
                    return {
                      date: metric.date,
                      impressions: metric.impressions,
                    }
                  }),
                  `${sheetTitle}_impressions.csv`,
                  false,
                  'csv',
                )
              }}>
              <Tooltip label={'Download'}>
                <div>
                  <DownloadIcon fill="stroke-black" />
                </div>
              </Tooltip>
            </GhostButton>
          </span>
        </div>
      </div>
      <div className={'h-[270px] p-2'}>
        <LineChart
          data={data ?? []}
          gradient={'green-to-cyan'}
          yKey={'impressions'}
          isLoading={isLoading}
          isPreviousData={isPrevious}
        />
      </div>
    </div>
  )
}
